import React from 'react';
import { Tooltip, Modal } from 'antd';
import { BASE_URL } from 'common';
import defaultConfig from 'common/config/providers.json';

const { confirm } = Modal;

export const Providers = ({ config, title, disable }) => (
  <div>
    {!(config && config.length === 0) &&
      <p className="auth__title--social">{title}</p>}

    <div className="auth__social-wrap">
      {(config || defaultConfig).map((item, i) => (
        item && <ProviderItemThumb key={item.id} content={item}
                           disable={disable}
                           placement={i === 0 ? 'topLeft' : 'top'} />
      ))}
    </div>
  </div>
)

export const ProviderItem = ({content}) => {
  const linkConfig = createHandlerConfig(content)

  return (
    <div className="auth__social-block">
      <a id={content.class} className="auth__social-link auth__social"  {...linkConfig}>
        <i className={`icon__social icon__social--${content.class}`} />
        <span className="auth__social-title">{content.title}</span>
      </a>
    </div>
  )
}

const ProviderItemThumb = ({content, placement, disable}) => {
  const linkConfig = createHandlerConfig(content)

  return (
    <div className="auth__social-item">
      <Tooltip placement={placement} title={content.title}>
        {!disable ?
          <a id={content.class} className="auth__social-link" {...linkConfig}>
            <i className={`icon__social icon__social--${content.class}`} />
          </a>
          : <div className="auth__social-link-disable">
            <i className={`icon__social icon__social--${content.class}`} />
          </div>
       }
      </Tooltip>
    </div>
  );
}

const createHandlerConfig = content => {
  const handleClick = () => {
    confirm({
      title: content.confirmation.title,
      content: (
        <div style={{whiteSpace: 'pre'}}>
          {content.confirmation.text}
        </div>
      ),
      okText: 'Продовжити',
      cancelText: 'Відмовитися',
      onOk() {
        window.location = BASE_URL + content.link;
      }
    })
  }

  return (
    content.confirmation ? {onClick: handleClick} : {href: BASE_URL + content.link}
  )
}